import gsap from 'gsap';

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.words .item');
  const wrapper = document.querySelector('.words');

  if (!items.length || !wrapper) return;

  let maxWidth = 0;
  items.forEach((el) => {
    el.style.position = 'relative';
    el.style.opacity = 1;
    el.style.transform = 'none';
    const width = el.offsetWidth;
    if (width > maxWidth) maxWidth = width;
    el.removeAttribute('style');
  });
  wrapper.style.width = `${maxWidth}px`;

  let currentIndex = 0;
  items[currentIndex].classList.add('visible');

  function animateToNext() {
    const current = items[currentIndex];
    const nextIndex = (currentIndex + 1) % items.length;
    const next = items[nextIndex];

    const nextWidth = next.offsetWidth;

    gsap.to(current, {
      y: -100,
      opacity: 0,
      duration: 0.6,
      ease: 'power2.inOut',
      onStart: () => current.classList.remove('visible'),
    });

    gsap.fromTo(
      next,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: 'power2.inOut',
        onStart: () => next.classList.add('visible'),
      },
    );

    gsap.to(wrapper, {
      width: nextWidth,
      duration: 0.6,
      ease: 'power2.inOut',
    });

    currentIndex = nextIndex;

    gsap.delayedCall(2.4, animateToNext);
  }

  gsap.delayedCall(1.8, animateToNext);
});
